import React, { useCallback } from 'react'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { useFormik } from 'formik'
import { useDispatch } from 'react-redux'
import { useRequests } from '../requests/useRequests'
import { RefreshActions } from '../state/refresh'
import { User } from '../types/user'

interface AddCommentDialogProps {
  userId: number
  username: string
  handleClose: (b: boolean) => void
}

export const AddCommentDialog = ({
  userId,
  username,
  handleClose
}: AddCommentDialogProps) => {
  const dispatch = useDispatch()
  const requestMaker = useRequests()

  const validate = (comment: { comment: string }): Partial<User> => {
    const errors: any = {}

    if (!comment?.comment || comment.comment === '') {
      errors.comment = 'Comment cannot be empty.'
    }

    return errors
  }

  const onSubmit = useCallback(
    async (comment: { comment: string }): Promise<void> => {
      try {
        await requestMaker.createComment({ ...comment, userId })
        dispatch(RefreshActions.refreshUserState())
        dispatch(
          RefreshActions.setToastMessage({
            message: 'Succesfully add comment'
          })
        )
        handleClose(true)
      } catch (e) {
        dispatch(
          RefreshActions.setToastMessage({
            message:
              'Error - fill all neccessary fields correctly and try again'
          })
        )
      }
    },
    [requestMaker, dispatch]
  )

  const formik = useFormik({
    initialValues: {
      comment: ''
    },
    onSubmit,
    enableReinitialize: true,
    validate
  })

  return (
    <>
      <Dialog open onClose={handleClose}>
        <form>
          <DialogTitle>Send Comment To: {username}</DialogTitle>
          <DialogContent>
            <TextField
              error={!!formik.errors.comment}
              helperText={formik.errors.comment}
              autoFocus
              margin='dense'
              id='comment'
              label='Comment'
              type='name'
              fullWidth
              variant='standard'
              value={formik.values.comment}
              onChange={formik.handleChange}
              required
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose as any}>Cancel</Button>
            <Button onClick={formik.handleSubmit as any}>Add</Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}

export default AddCommentDialog
